import React from "react";
import Immutable from "immutable";
import * as TargetsAPI from "js/oneview/targets/targets-api";
import {parseTargetDates} from "js/oneview/targets/utils";

export const useTargets = (kpiId, qualifierType, qualifierId) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [loadTargetsError, setLoadTargetsError] = React.useState(null);
  const [targets, setTargets] = React.useState(Immutable.List());

  const loadTargets = React.useCallback(() => {
    setIsLoading(true);
    setLoadTargetsError(null);

    return TargetsAPI
        .loadTargets(kpiId, {qualifierType, qualifierId})
        .then(loadedTargets => {
          const processedTargets = loadedTargets
              .filterNot(t => t.get("deleted"))
              .map(parseTargetDates)
              .sortBy(t => -t.get("targetStart"));

          setTargets(processedTargets);
          setLoadTargetsError(null);
        })
        .catch(() => {
          setLoadTargetsError("Unable to load targets");
        })
        .finally(() => {
          setIsLoading(false);
        });
  }, [kpiId, qualifierType, qualifierId]);

  React.useEffect(() => {
    loadTargets();
  }, [loadTargets]);

  return {
    targets,
    setTargets,
    isLoading,
    loadTargetsError,
    loadTargets
  };
};